var React = require('react');

function G2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"G2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M.13,42.57A40,40,0,0,0,39.06,79.33L32.61,0A40,40,0,0,0,.13,42.57Z","fill":"#73c9bd","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M35.52,40.44,32.9,81.1A41.12,41.12,0,0,0,72.25,42.68Z","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

G2.defaultProps = {"viewBox":"0 0 72.25 81.1"};

module.exports = G2;

G2.default = G2;
